// removed by extract-text-webpack-plugin
module.exports = {"scroll-track":"scroll-track___XJnoT","scroll-track-hidden":"scroll-track-hidden___s644C","scroll-thumb":"scroll-thumb___2jFBY","scroll-thumb-hidden":"scroll-thumb-hidden___17a9V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollBar/ScrollBar.scss
// module id = MJII
// module chunks = 46